<template>
    <a :href="`/api/users/auth/google/token/${inviteToken}`" data-test-id="google-sign-in">
        <img
            src="@/img/GoogleSignInButton.png"
            srcset="@/img/GoogleSignInButton.png 1x, @/img/GoogleSignInButton@2x.png 2x"
            :alt="$t('auth.login.signInWithGoogle')"
            class="tw-cursor-pointer tw-inline-block tw-transform tw-duration-200 hover:tw-scale-105"
            loading="lazy"
        />
        <div class="tw-sr-only">{{ $t("auth.login.signInWithGoogle") }}</div>
    </a>
</template>

<script>
export default {
    props: {
        inviteToken: {
            type: String,
            default: "none",
        },
    },
};
</script>
